import { useState, useEffect } from "react";
import Project from "./Project";

const ProjectList = () => {
    const [projectList, setProjectList] = useState([]);

    const SERVER_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_DEV_SERVER_URL : process.env.REACT_APP_PROD_SERVER_URL;

    useEffect(() => {
        getProjectList();
        //getProjects();
    }, []);

    const getProjectList = () => {
        fetch(`${SERVER_URL}/getProjects`, {
            method: 'GET',
            headers: {
                "content-encoding": null,
                "gzip": true
            }
        })
            .then(result => result.json())
            .then((data) => { console.log(data); setProjectList(data) })
            .catch((err) => console.log("error in fetching data - " + err));
    }


    return (
        <div className="container project-list">
            {
                projectList && projectList.map((proj, index) =>
                    <div key={index}>
                        <Project proj={proj} />
                    </div>
                )
            }
        </div>
    );
}

export default ProjectList;